import './carousel.scss';
import {encodeUriParts} from '../../Shared/Assets/encodeUriParts';
import {CarouselUtils} from '../../Shared/Assets/carousel-utils';

import * as CarouselConfiguration from './carousel-configuration.json';
import Swiper from 'swiper';
import { Navigation, Pagination, FreeMode } from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
Swiper.use([Navigation, Pagination,FreeMode]);

class Carousels {
	init() {
		const carouselSectionEls = document.querySelectorAll('[data-role="carousel-section"]');
		carouselSectionEls.forEach(sectionEl =>{
			this.buildEditorial(sectionEl);
		});
	}
	buildEditorial(sectionEl) {
		if (CarouselUtils.isMobile()) {
			sectionEl.classList.add('has-touch');
		} else {
			sectionEl.classList.remove('has-touch');
		}
		
		const swiperSectionEl = sectionEl.querySelector('[data-role="swiper-section"]');
		const configs = this.getEditorialConfigs(sectionEl,swiperSectionEl);
		const swiperEl = swiperSectionEl.querySelector('[data-role="swiper"]');
		new Swiper(swiperEl, configs);
	}
	getEditorialConfigs(sectionEl,swiperSectionEl) {
		if (CarouselUtils.isMobile()) {
			const slidesOffset = CarouselUtils.getSlidesOffset(sectionEl);
			const spaceBetween = 8;
			const componentName = swiperSectionEl.getAttribute("data-component-name");
			const slides  = CarouselConfiguration[componentName]?.SlidesOnMobile ?? 2;
			return {
				edgeSwipeDetection: true,
				watchSlidesVisibility: true,
				watchSlidesProgress: true,
				roundLengths: true,

				//responsive
				slidesPerView: slides,
				spaceBetween,
				slidesOffsetBefore: slidesOffset,
				slidesOffsetAfter: slidesOffset
			}
		}
		
		//desktop
		const pagination = CarouselUtils.usePagination(swiperSectionEl);
		const navigation = CarouselUtils.useNavs(swiperSectionEl, CarouselUtils.isLargeScreen());
		return {
			//https://swiperjs.com/swiper-api
			watchSlidesVisibility: true,
			watchSlidesProgress: true,
			roundLengths: true,
			speed:500,

			//responsive
			slidesPerView: 2,
			spaceBetween: 16,
			pagination,
			navigation,
			breakpoints: {
				768: {
					slidesPerView: 3,
					slidesPerGroup: 3
				},
				1200: {
					slidesPerView: 4,
					slidesPerGroup: 4
				}
			},
		}
	}
}

window.addEventListener("load", () => new Carousels().init());